import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { CallbackResultType } from '../../../enums/CallbackResultType';
import { strings } from '../../../resources/strings';
import { ReportService } from '../../Reports/ReportService';
import { GetSimplePackingLabelInput } from './GetSimplePackingLabelInput';

export class GetSimplePackingLabelService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  fileHandle = (input: GetSimplePackingLabelInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GetSimplePackingLabelInput>(
      `${this.baseUrlSislogV2Api}/v2/simple-packing-label/file`,
      input
    ).then(result => {
      this.report.download(result, `${strings.LabelsOfPackingSimple}.zpl`);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
      callback?.(CallbackResultType.Error);
    });
  }

  pdfHandle = (input: GetSimplePackingLabelInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GetSimplePackingLabelInput>(
      `${this.baseUrlSislogV2Api}/v2/simple-packing-label/pdf`,
      input
    ).then(result => {
      this.report.openPdf(result);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
      callback?.(CallbackResultType.Error);
    });
  }
}